<template>
    <div>
        <p class="m-0">
           <span class="show-platforms" @click="show = !show">
              <span v-if="!show">
                  Показать {{ platformsPluralForm }} <i class="el-icon-arrow-down"></i>
              </span>
               <span v-else>
                  Скрыть {{ platformsPluralForm }} <i class="el-icon-arrow-up"></i>
               </span>
           </span>
        </p>
        <transition name="el-zoom-in-top">
            <ul v-show="show">
                <li v-for="platform in platforms" :key="platform.id" class="mb-1">
                    <a :href="'https://vk.com/club'+platform.group_id" target="_blank">
                        <img class="pl-avatar" :src="platform.avatar">
                        {{ getTitle(platform.name) }}
                    </a>
                </li>
            </ul>
        </transition>
    </div>
</template>

<script>
    export default {
        name: "PlatformsSpoilerList",
        props: {
            platforms: Array
        },
        data() {
            return {
                show: false
            }
        },
        methods: {
            getTitle(title) {
                let name = title.substring(0, 30);
                name += ' ' + title.length > 30?'...':'';
                return name;
            },
            plural(forms, n) {
                let idx;
                if (n % 10 === 1 && n % 100 !== 11) {
                    idx = 0; // many
                } else if (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)) {
                    idx = 1; // few
                } else {
                    idx = 2; // one
                }
                return forms[idx] || '';
            }
        },
        computed: {
            platformsPluralForm() {
                return this.platforms.length + ' ' + this.plural(['площадку', 'площадки', 'площадок'], this.platforms.length);
            }
        }
    }
</script>

<style scoped>
    .pl-avatar {
        width: 15px;
        border-radius: 50%;
    }
    ul {
        margin-top: 5px;
        padding-inline-start: 0px;
    }
    ul a {
        color: #606266;
    }
    .show-platforms {
        color: #409EFF;
        cursor: pointer;
    }
</style>